import { useState } from 'react';
import { useAuth } from '../utils/AuthContext';
import { onboardClinic } from '../utils/apiCalls';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function RegisterClinic({ onSuccess }) {
    const { token } = useAuth();
    const [clinicName, setClinicName] = useState('');
    const [locationName, setLocationName] = useState('');
    const [message, setMessage] = useState('');
    const [timezoneValue, setTimezoneValue] = useState('');
    const [registrarCredentials, setRegistrarCredentials] = useState(null);
    const [loading, setLoading] = useState(false);

    const timezones = [
        "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
    ]

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setRegistrarCredentials(null);

        const trimmedName= clinicName.trim();
        const trimmedLocation = locationName.trim();

        if (!trimmedName) {
            setMessage('Clinic name cannot be empty.');
            return;
        }

        if (!trimmedLocation) {
            setMessage('Location name cannot be empty.');
            return;
        }

        if (!timezoneValue) {
            setMessage('Please select clinic timezone.');
            return;
        }

        setLoading(true);

        const clinicData = {
            clinic_name: trimmedName,
            location_name: trimmedLocation,
            clinic_timezone: timezoneValue,
        };

        try {
            const data = await onboardClinic(clinicData, token);
            setMessage(data.message || 'Clinic onboarded successfully.');
            setRegistrarCredentials(data.registrar_credentials);
            setClinicName('');
            setLocationName('');
            setTimezoneValue('');
            onSuccess?.();
        } catch (error) {
            console.error('Failed to onboard clinic', error);
            setMessage(`Error creating clinic, please check logs and try again`);
        } finally {
            setLoading(false);
        }
    };
    


    return (
        <div className='p-6 max-w-md mx-auto'>
            <h2 className='text-xl front-bold mb-4'>
                Register Clinic
            </h2>

            <form onSubmit={handleSubmit} className='space-y-3'>
                <input type='text' value={clinicName} onChange={(event) => setClinicName(event.target.value)} placeholder='Enter clinic name' className='w-full border rounded px-3 py-2'/>
                <input type='text' value={locationName} onChange={(event) => setLocationName(event.target.value)} placeholder='Enter first location name' className='w-full border rounded px-3 py-2'/>
                <select value={timezoneValue} onChange={(event => setTimezoneValue(event.target.value))} className='w-full border rounded px-3 py-2'>
                    <option value='' default disabled>
                        -Select Timezone-
                    </option>
                    {timezones.map((tz) => (
                        <option key={tz} value={tz}>
                            {tz}
                        </option>
                    ))}
                </select>
                <button type='submit' disabled={loading} className={`w-full bg-docpgrPurple text-white px-4 py-2 rounded shadow-md hover:opacity-90 transform transition-transform duration-200 hover:scale-105 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}> 
                    { loading ? 'Creating...' : 'Onboard Clinic'}
                </button>
            </form>

            {message && <p className='mt-3 text-sm'>{message}</p>}

            {registrarCredentials && (
                <div className='mt-6 bg-gray-50 border rounded-lg p-4 text-sm'>
                    <h3 className='font-semibold texet-gray-800 mb-2 text-center'>
                        Registrar Credentials
                    </h3>
                    <p>
                        <span className='font-meidum'>Username:</span>{' '}{registrarCredentials.username}
                    </p>
                    <p>
                        <span className='font-meidum'>Temporary Password:</span>{' '}{registrarCredentials.password}
                    </p>
                    <p className="mt-2 text-gray-500 text-xs">
                        Be sure to copy these credentials securely - they will not be shown again.
                    </p>
                
                </div>
            )}

        </div>
    )
}